import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import { RouterLink } from 'src/routes/components';
import { paths, newSearchParams } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';
import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

export function AgreedTerms({ sx, ...other }) {
  const { t, currentLang } = useTranslate();

  return (
    <Box
      component="div"
      sx={[
        {
          py: 3,
          textAlign: 'center',
          typography: 'caption',
          color: 'text.secondary',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {`${t('By using')} ${CONFIG.appName}, ${t('declares to agree with the')}`}
      <Box>
        <Link
          target="_blank"
          color="text.primary"
          component={RouterLink}
          href={`${paths.legal.terms}${newSearchParams({ country: currentLang.countryName })}`}
        >
          {t('Terms of service')}
        </Link>
        {t(' and ')}
        <Link
          target="_blank"
          color="text.primary"
          component={RouterLink}
          href={`${paths.legal.privacy}${newSearchParams({ country: currentLang.countryName })}`}
        >
          {t('Privacy policy')}
        </Link>
        .
      </Box>
    </Box>
  );
}
